class ScrollBar {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    $(document).ready(function () {
      var $innerDiv = $('.js-scroll-bar > div');

      // 全体のスクロール可能な高さを取得
      var totalHeight = $(document).height() - $(window).height();

      $(window).on('scroll', function () {
        // 現在のスクロール位置を取得
        var scrollTop = $(window).scrollTop();

        // スクロールの進行度を計算（0から1までの値）
        var scrollPercentage = scrollTop / totalHeight;

        // .js-process-bar > divの新しい高さを%で計算
        var newHeight = scrollPercentage * 100;

        // 新しい高さを適用
        $innerDiv.css('height', newHeight + '%');
      });
    });

  }
}
